export function initSplash() {
  setTimeout(() => {
    const fill = document.getElementById('splashFill');
    if (fill) fill.style.width = '100%';
  }, 100);
  setTimeout(() => {
    document.getElementById('splash')?.classList.add('off');
  }, 1500);
}
